import { Container, Row, Col, Button } from "react-bootstrap";
import { Form } from "antd";
import "../../src/index.css";
import logo from "../assets/images/yelogo.png";
import { useState } from "react";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import IyeInput from "components/IyeInput";
import IyePopup from "components/IyePopup";
import { Link } from "react-router-dom";

const Signup = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log(values);
  };

  const [otpVisible, setOtpVisible] = useState(false);

  const handleSignup = () => {
    // Trigger OTP modal after sign up logic
    setOtpVisible(true);
  };

  const handleVerifyOtp = (otp: string) => {
    console.log("OTP entered:", otp);
    setOtpVisible(false);
  };

const [showConfirmPass, setShowConfirmPass] = useState(false);

  return (
    <div className="login-bg">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="login-card">
              {/* LEFT PANEL */}
              <div className="login-left">
                <img
                  src={logo}
                  alt="illustration"
                  className="login-illustration"
                />
              </div>

              {/* RIGHT PANEL */}
              <div className="login-right">
                <h4 className="mb-2 ms-5">Create an Account 👋</h4>
                <p className="text-muted small ms-5">
                  Welcome here, Enter your information for creating your account
                </p>

                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off" // ✅ Disable browser autofill
                  className="mt-3 ms-5 me-5"
                >
                  {/* USERNAME */}
                  <IyeInput
                    type="text"
                    name="username"
                    placeholder="Enter Username"
                    required
                    requiredMessage="Username is required"
                  />

                  <IyeInput
                    type="email"
                    name="email"
                    placeholder="Enter User Email"
                    required
                    requiredMessage="User Email is required"
                  />

                  {/* PHONE */}
                  <IyeInput
                    type="phone"
                    name="phone"
                    placeholder="Enter Phone Number"
                    required
                    requiredMessage="Phone is required"
                  />

                  {/* PASSWORD */}
                  <IyeInput
                    type={showConfirmPass ? "text" : "password"}
                    name="password"
                    placeholder="Confirm Password"
                    required
                    requiredMessage="Password is required"
                    prefix={<i className="fa fa-lock" />}
                    suffix={
                      showConfirmPass ? (
                        <EyeOutlined
                          onClick={() => setShowConfirmPass(false)}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => setShowConfirmPass(true)}
                        />
                      )
                    }
                  />

                  <>
                    <Link to="/admin-panel">
                    <Button
                      type="submit"
                      className="login-btn w-100 rounded-pill p-3"
                    >
                      Sign Up
                    </Button>
                    </Link>

                    <IyePopup
                      visible={otpVisible}
                      onClose={() => setOtpVisible(false)}
                      phoneNumber="+234 803 123 4567"
                      onVerify={handleVerifyOtp}
                    />
                  </>

                  <div className="divider">OR</div>

                 

                  <p className="text-center mt-4 small">
                    Already have an account? <a href="#" onClick={handleSignup} className="loginlink">Login</a>
                  </p>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Signup;
